/**
 * state属性必须使用mutation改变
 * 跟级别的mutation
 */
const mutations = {
  changeCollapse (state) {
    state.isCollapse = !state.isCollapse
  },
  handleMenuList (state,data) {
    state.menuList = data
  },

  handleRoutePath (state,data) {
    state.routePath = data
  },
  handleUserInfo (state,data) {
    state.userInfo = data
  },
  handleUserPermissions (state,data) {
    state.userPermissions = data
  },
  changeRespErrMsgBoxMark (state,data) {
    state.responseErrorMessageBoxMark = data
  },
  changeLoadingStatus (state,data) {
    state.loadingStatus = data
  },
}

export default mutations